import { useQuery } from '@tanstack/react-query';
import Fetch from '../../../../../../core/util/core/Fetch';
import config from '../../../../../config/config';

/**
 * Anos do Censo importados para a cidade, do mais recente ao mais antigo.
 */
const useCensusYears = cityId =>
    useQuery({
        queryKey: ['census-years', cityId],
        queryFn: async () => {
            const years = await Fetch.post(config.endpoints.backend + 'governanceroom/sectors/census/years', {
                city_id: cityId
            });

            // Fetch.post não rejeita em erro HTTP: devolve o corpo { message }.
            if (!Array.isArray(years)) {
                throw new Error(years?.message || 'Erro ao buscar anos do Censo.');
            }

            return years.map(String);
        },
        enabled: Boolean(cityId)
    });

export default useCensusYears;
